import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-medical-team',
  standalone: true,
  imports: [],
  templateUrl: './medical-team.component.html',
  styleUrl: './medical-team.component.scss'
})
export class MedicalTeamComponent implements OnInit {

  constructor(private metaService: Meta,
    private titleService: Title, private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    const homeSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "NCare IVF Kannur, Kerala",
      "image": "https://ncareivfkannur.com/assets/images/header/logo.svg",
      "@id": "https://ncareivfkannur.com/",
      "url": "https://ncareivfkannur.com/medical-team",
      "telephone": "8606443030",
      "priceRange": "₹",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Balram Memorial Buidling, N.E, Rajiv Gandhi Rd",
        "addressLocality": "Kannur, Kerala",
        "postalCode": "670001",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 11.8710259,
        "longitude": 75.3641411
      },
      "sameAs": [
        "https://www.facebook.com/people/Ncare-IVF-Kannur/61574105283962/",
        "https://www.instagram.com/ncareivfkannur/",
        "https://www.youtube.com/@NCAREIVFKANNUR/"
      ]
    }

    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(homeSchema);
    this.renderer.appendChild(this.document.head, script);



    this.titleService.setTitle('Expert Fertility Specialists in Kannur | Meet Our Medical Team');
    this.metaService.updateTag({
      name: 'description',
      content: 'Meet the experienced fertility doctors and IVF specialists at NCARE IVF Centre in Kannur. Our dedicated medical team offers compassionate care and advanced reproductive treatments tailored to your needs.'
    });

    this.metaService.updateTag({
      name: 'keywords',
      content: 'Fertility Specialists in Kannur, IVF Doctors in Kannur, NCARE IVF Medical Team, Reproductive Health Experts, Best Fertility Doctors'
    });

    this.metaService.updateTag({
      property: 'og:title',
      content: 'Expert Fertility Specialists in Kannur | Meet Our Medical Team'
    });

    this.metaService.updateTag({
      property: 'og:description',
      content: 'Meet the experienced fertility doctors and IVF specialists at NCARE IVF Centre in Kannur. Our dedicated medical team offers compassionate care and advanced reproductive treatments tailored to your needs.'
    });
  }

}
